import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ModalService } from 'src/app/services/modal.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { PersistenceService } from 'src/app/services/persistence.service';

@Component({
  selector: 'app-initial-login',
  templateUrl: './initial-login.component.html',
  styleUrl: './initial-login.component.scss'
})
export class InitialLoginComponent {
  isSubmitting = false;
  isFormCompleted = false;
  loginID;
  regcode;
  errorMsg;
  attendeeTypes;
  attendeeTypeLogin;

  constructor(
    private authenticationService:AuthenticationService,
    private navigationService: NavigationService,
    private persistenceService: PersistenceService,
    private modalService: ModalService,
    private router: Router){
      this.attendeeTypes = [
        {
          name: "Advisory Board / Council Member",
          code: "adviseCouncil" 
        },
        {
          name: "Top Producing Financial Professionals",
          code: "topPros"
        },
        {
           name: "Support Staff",
           code: "admin"
         },
         {
           name: "Financial Professionals",
           code: "financePros"
         },
        {
           name: "Corporate Guest",
           code: "corpGuest"
        },
        {
           name: "Event Producer",
           code: "eventProducer"
        },
        {
          name: "Home Office",
          code: "homeOffice"
        },
        {
           name: "Strategic Partner / Speaker",
           code: "strategySpeaker"
        },
        {
           name: "Vendor",
           code: "vendor"
        },
        {
           name: "Other",
           code: "other"
        }
      ]
  }

  forward(){
    if(!this.isSubmitting){
      this.isFormCompleted = true;
      this.isSubmitting = true;
      const creds: any = {};
      if (this.loginID) {
        creds.username = this.loginID;
        creds.password = 'password';
        this.authenticationService.initialLogin(creds, this.regcode).then(() => {
          // promise resolved
          if(this.regcode){
            this.authenticationService.mapRegCode(this.regcode);
          }
          this.navigationService.forward();
        }, (err) => {
          this.isSubmitting =false;
          this.errorMsg = err;
        });
      } else {
        this.isSubmitting =false;
        this.errorMsg = 'Please select your Attendee Type from the dropdown.';
      }
    }
  }
  declineButtonClick() {

    this.persistenceService.testStorage();
    this.persistenceService.clear();

    const creds: any = {};
    console.log(this.loginID);
    creds.username = this.loginID;
    creds.password = 'password';

    if (this.loginID) {
      this.authenticationService.initialLogin(creds, this.regcode).then(() => {
        //  promise resolved
        //this.router.navigate(['/invitation']);
        this.authenticationService.updateProfile('CANCELLED', "Declined from Login Page").subscribe(() => {
          this.router.navigate(['decline']);
      });

      }, (err) => {
        this.errorMsg = err;
      });
    }

  }

  openModal(copy, title, actionButtonText) {
    this.modalService.openModal(copy, title, actionButtonText);
  }
}
